(function() {
  'use strict';

  angular.module('component.dashboardTemplates', []);
})();
